module.exports = __webpack_public_path__ + "static/media/triangle-android.354519d7.svg";